<template>
  <Header />
  <div class="legal-page">
    <main class="legal-content">
      <div class="legal-container">
        <header class="legal-header">
          <h1 class="legal-title">Privacy Policy</h1>
          <h2 class="legal-updated">Ultimo aggiornamento: 14 marzo 2026</h2>
          <div>
            Questa informativa descrive come trattiamo i dati personali sul sito sportemocracy.it.
          </div>
        </header>

        <section class="legal-section">
          <h2>Introduzione</h2>
          <div>
            La presente Privacy Policy descrive le modalità con cui Sportemocracy Srls tratta i dati personali degli utenti che visitano il sito sportemocracy.it. 
            Questa informativa è fornita ai sensi della normativa applicabile in materia di protezione dei dati personali e ha lo scopo di spiegare in modo chiaro e trasparente quali dati vengono trattati e per quali finalità.
          </div>
        </section>

        <section class="legal-section">
          <h2>Titolare del trattamento</h2>
          <div>
            Il titolare del trattamento dei dati è Sportemocracy Srls. 
            Per qualsiasi richiesta o chiarimento relativo alla presente Privacy Policy è possibile contattarci all’indirizzo email:
            <a class="legal-link" href="mailto:info@sportemocracy.it">info@sportemocracy.it</a>.
          </div>
        </section>

        <section class="legal-section">
          <h2>Tipologie di dati trattati</h2>
          <div>
            Sul sito sportemocracy.it vengono trattate le seguenti categorie di dati personali:
            <ul>
              <li>Dati forniti direttamente dall'utente tramite il form di contatto: nome, cognome, indirizzo email, numero di telefono (opzionale) e messaggio. Questi dati vengono raccolti esclusivamente quando l'utente compila e invia il form di contatto.</li>
              <li>Dati di navigazione e dati tecnici aggregati: raccolti tramite strumenti di analisi statistica, non consentono l'identificazione diretta dell'utente.</li>
            </ul>
          </div>
        </section>

        <section class="legal-section">
          <h2>Finalità del trattamento</h2>
          <div>
            I dati trattati sono utilizzati esclusivamente per le seguenti finalità:
            <ul>
              <li>Analizzare in forma aggregata l’utilizzo del sito e il traffico di navigazione.</li>
              <li>Migliorare i contenuti, le funzionalità e l’esperienza utente del sito.</li>
            </ul>

            I dati non vengono utilizzati per finalità di marketing, profilazione o pubblicità.
          </div>
        </section>

        <section class="legal-section">
          <h2>Base giuridica</h2>
          <div>
            Il trattamento dei dati inseriti nel form di contatto si basa sul consenso esplicito dell'utente, espresso tramite apposita checkbox prima dell'invio del form, ai sensi dell'art. 6, par. 1, lett. a) del GDPR.
            Il trattamento dei dati effettuato tramite strumenti di analisi statistica si basa sul consenso dell'utente, espresso tramite il banner di gestione dei cookie. 
            In assenza di consenso, i cookie analitici non vengono attivati.
          </div>
        </section>

        <section class="legal-section">
          <h2>Modalità di trattamento</h2>
          <div>
            Il trattamento dei dati avviene mediante strumenti informatici e telematici, adottando misure tecniche e organizzative adeguate a garantire la sicurezza e la riservatezza dei dati, in conformità alle normative vigenti.
          </div>
        </section>

        <section class="legal-section">
          <h2>Servizi di terze parti</h2>
          <div>
            Il sito si avvale dei seguenti servizi di terze parti che agiscono in qualità di responsabili del trattamento:
            <div><b>Google Analytics 4</b> — servizio di analisi fornito da Google LLC, configurato con anonimizzazione dell'indirizzo IP e senza funzionalità pubblicitarie o di profilazione. Privacy policy: <a class="legal-link" href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></div>
            <div><b>Brevo SAS (Francia)</b> — utilizzato per l'invio delle email generate dal form di contatto. I dati inseriti nel form (nome, cognome, email, telefono, messaggio) vengono trasmessi a Brevo esclusivamente per la consegna della comunicazione e non vengono conservati da Brevo dopo l'invio. Brevo è un'azienda con sede nell'Unione Europea e opera in conformità al GDPR. Privacy policy: <a class="legal-link" href="https://www.brevo.com/it/legal/privacypolicy/" target="_blank" rel="noopener noreferrer">https://www.brevo.com/it/legal/privacypolicy/</a></div>
            <div><b>Netlify Inc. (USA)</b> — piattaforma su cui è ospitato il sito. I dati trasmessi tramite il form transitano temporaneamente sui server Netlify esclusivamente per l'elaborazione della richiesta, senza essere conservati. Il trasferimento verso gli USA avviene sulla base delle Clausole Contrattuali Standard (SCC) approvate dalla Commissione Europea. Privacy policy: <a class="legal-link" href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer">https://www.netlify.com/privacy/</a></div>
          </div>
        </section>

        <section class="legal-section">
          <h2>Trasferimento dei dati</h2>
          <div>
            Alcuni dati raccolti tramite servizi di terze parti possono essere trattati al di fuori dell'Unione Europea. 
            In tali casi, il trasferimento avviene nel rispetto delle garanzie previste dalla normativa applicabile, in particolare mediante le Clausole Contrattuali Standard (SCC) approvate dalla Commissione Europea.
          </div>
        </section>

        <section class="legal-section">
          <h2>Destinatari</h2>
          <div>
            I dati non vengono diffusi né comunicati a soggetti terzi diversi dai fornitori di servizi tecnici strettamente necessari al funzionamento del sito, degli strumenti di analisi e del servizio di invio email, come indicato nella sezione "Servizi di terze parti".
          </div>
        </section>

        <section class="legal-section">
          <h2>Periodo di conservazione</h2>
          <div>
            I dati inseriti nel form di contatto vengono conservati dal titolare per il tempo strettamente necessario a gestire la richiesta dell'utente e comunque non oltre 12 mesi dalla ricezione.
            I dati raccolti tramite strumenti di analisi statistica sono conservati secondo i termini previsti dalle policy dei fornitori dei servizi utilizzati.
          </div>
        </section>

        <section class="legal-section">
          <h2>Diritti dell'utente</h2>
          <div>
            Gli utenti possono esercitare, nei limiti previsti dalla normativa applicabile, i seguenti diritti:
            <ul>
              <li>Ottenere l’accesso ai propri dati.</li>
              <li>Richiedere la cancellazione o la limitazione del trattamento.</li>
              <li>Opporsi al trattamento.</li>
              <li>Revocare in qualsiasi momento il consenso precedentemente espresso.</li>
            </ul>
            Per esercitare tali diritti è possibile contattare il titolare del trattamento all’indirizzo email:
            <a class="legal-link" href="mailto:info@sportemocracy.it">info@sportemocracy.it</a>.
          </div>
        </section>

        <section class="legal-section">
          <h2>Minori</h2>
          <div>
            Il sito sportemocracy.it è rivolto a un pubblico maggiorenne e non è destinato a minori di età.
          </div>
        </section>

        <section class="legal-section">
          <h2>Servizi futuri</h2>
          <div>
            Eventuali servizi, applicazioni o piattaforme accessibili tramite domini o sottodomini differenti (ad esempio app.sportemocracy.it) saranno disciplinati da informative privacy dedicate e separate dalla presente.
          </div>
        </section>

        <section class="legal-section">
          <h2>Modifiche alla Privacy Policy</h2>
          <div>
            Potremmo aggiornare periodicamente questa Privacy Policy per riflettere modifiche normative, tecniche o operative. 
            In caso di aggiornamenti, la data di "Ultimo aggiornamento" indicata in cima alla pagina verrà modificata di conseguenza.
          </div>
        </section>

        <section class="legal-section">
          <h2>Contatti</h2>
          <div>
            Per domande sulla Privacy Policy puoi scriverci a
            <a class="legal-link" href="mailto:info@sportemocracy.it">info@sportemocracy.it</a>.
          </div>
          <div>
            Consulta anche la
            <router-link class="legal-link" to="/legal/cookie">Cookie Policy</router-link>.
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '../../components/Header.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    Footer,
    Header
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/colors.scss';

.legal-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: $neutral-light;
  color: $black;
  font-weight: 400;
  overflow-x: hidden;
  padding-top: var(--header-height);
}

.legal-content {
  flex: 1;
}

.legal-container {
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  box-sizing: border-box;
}

.legal-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.legal-title {
  font-size: 2.1rem;
  font-weight: 400;
  line-height: 1.1;
  margin: 0;
}

.legal-updated {
  font-size: 0.95rem;
  margin: 0;
  color: rgba($black, 0.6);
  font-weight: 400;
}

.legal-header div{
  font-size: 1rem;
  line-height: 1.7;
}

.legal-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba($black, 0.08);
}

.legal-section:first-of-type {
  border-top: none;
  padding-top: 0;
}

.legal-section h2 {
  font-size: 1.35rem;
  color: $black;
  font-weight: 400;
  margin: 0;
}

.legal-section div,
.legal-section li {
  font-size: 1rem;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.legal-section ul {
  margin: 0.75rem 0 0 1.25rem;
  padding: 0;
}

.legal-link {
  color: $primary;
  text-decoration: underline;
}

.legal-link:hover {
  color: $secondary-warm;
}

@media (min-width: 900px) {
  .legal-container {
    padding: 3.5rem 2.5rem 4.5rem;
    gap: 2rem;
  }

  .legal-title {
    font-size: 2.6rem;
  }

  .legal-section h2 {
    font-size: 1.5rem;
  }
}
</style>
